import { jsx as t } from "react/jsx-runtime";
import i from "@mui/joy/ListItem";
import o from "@mui/joy/ListItemButton";
const r = () => t(i, { sx: { root: { paddingRight: 0, paddingLeft: 0 } }, children: t(o, { disabled: true, children: "Нічого не знайдено" }) });
export {
  r as NotFoundListItem
};
//# sourceMappingURL=NotFoundListItem.js.map
